import React from 'react';

export function XpnsrSkeleton({ width = '100%', height = '1em', className = '', style = {}, ...rest }) {
  return (
    <span
      aria-hidden="true"
      className={`xp-skel ${className}`.trim()}
      style={{ width, height, ...style }}
      {...rest}
    />
  );
}

export function XpnsrSkeletonBlock({ children, className = '', style = {} }) {
  return (
    <div className={`xp-skel-block ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}

export function XpnsrCardSkeleton({ rows = 3, withHeader = true }) {
  return (
    <div className="xp-skel-card" data-testid="skeleton-card">
      {withHeader ? (
        <div className="xp-skel-card-header">
          <XpnsrSkeleton width="40%" height={14} />
          <XpnsrSkeleton width={48} height={20} />
        </div>
      ) : null}
      <div className="xp-skel-card-body">
        {Array.from({ length: rows }).map((_, i) => (
          <XpnsrSkeleton key={i} width={i === rows - 1 ? '70%' : '100%'} height={12} />
        ))}
      </div>
    </div>
  );
}

export function XpnsrTableSkeleton({ rows = 5, columns = 4 }) {
  return (
    <div className="xp-skel-table" data-testid="skeleton-table">
      <div className="xp-skel-table-row xp-skel-table-head">
        {Array.from({ length: columns }).map((_, i) => (
          <XpnsrSkeleton key={`h-${i}`} width="60%" height={10} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={`r-${r}`} className="xp-skel-table-row">
          {Array.from({ length: columns }).map((_, c) => (
            <XpnsrSkeleton key={`r-${r}-${c}`} width={c === 0 ? '90%' : '60%'} height={12} />
          ))}
        </div>
      ))}
    </div>
  );
}

export default XpnsrSkeleton;
